<template>
    <div class='component-page'>
        <!--文本搜索位置-->
        <div class="filter-area">
            <Row style='text-align: center;' class='add_search'>
                <Col span="4">
                    <Input search v-model="formItem.sys_order_num" placeholder="输入订单号" @on-search="handleSearch" style="width:100%;" />
                </Col>
                <Col span="4">
                    <Input search v-model="formItem.phone" placeholder="输入手机号" @on-search="handleSearch" style="width:100%;" />
                </Col>
            </Row>
        </div>
        <!--下拉搜索位置-->
        <div class="edittable-table-height-con">
            <Row class='search-select'>
                <Col span="8">
                    <span>时间：</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='start_time' style="width: 130px;display:inline-block" @on-change='changStarttime'></Date-picker>
                    <span style="margin: 0 10px;">至</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='end_time' style="width: 130px;display:inline-block" @on-change='changEndtime'></Date-picker>
                </Col>
              
                <Col span='6'>
                    <Select v-model="formItem.school_id" placeholder="校区" @on-change="handleSearch" clearable style="width:300px">
                        <Option v-for="item in schoolList" :value="item.school_id" :key="item.school_id">{{ item.school_name }}</Option>
                    </Select>
                   
                </Col>
                <Col span='6'>
                    <Select v-model="formItem.proxy_id" placeholder="代理" @on-change="handleSearch" clearable style="width:200px">
                        <Option v-for="item in proxyList" :value="item.proxy_id" :key="item.proxy_id">{{ item.proxy_name }}</Option>
                    </Select>
                </Col>
                <Col span='4'>
                    <Select v-model="formItem.pay_status" placeholder="订单状态" @on-change="handleSearch" clearable style="width:200px">
                        <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </Col>
                             
            </Row>
           
            <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
            <div>
                总订单金额：{{total_money}}
            </div>
            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right'  size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
        </div>
    
        <Modal v-model="detailsModal" width="750" title="详情">
            <div class='details-box'>
                <p><span>订单号：{{detailsFrom.sys_order_num}}</span><span>订单状态：{{detailsFrom.sys_status}}</span></p>
                <p><span>下单时间：{{detailsFrom.create_at}}</span><span>支付时间：{{detailsFrom.pay_at}}</span></p>
                <p style='font-size:14px;line-height:40px;font-weight:900'>买家信息</p>
                <p><span>姓名：{{detailsFrom.nickname}}</span><span>手机号：{{detailsFrom.phone}}</span></p>
    
            </div>
            <div v-if='refundStatus' class='details-box'>
                <p style='font-size:14px;line-height:40px;font-weight:900'>退款信息</p>
                <p><span>经办人：{{detailsFrom.refund_agent}}</span><span>退款金额：{{detailsFrom.refund_price}}</span></p>
                <p><span>退款时间：{{detailsFrom.create_at}}</span></p>
                <p>退款说明：{{detailsFrom.refund_desc}}</p>
            </div>
            <div class='details-box'>
                <p style='font-size:14px;line-height:40px;font-weight:900'>商品信息</p>
                <p><span>名称：{{detailsFrom.name}}</span><span>数量：{{detailsFrom.goods_num}}</span><span v-if='detailsFrom.type==2'>袋鼠币：{{detailsFrom.goods_price}}</span><span v-if='detailsFrom.type==1'>价格：{{detailsFrom.goods_price}}</span></p>
                <img :src="detailsFrom.cover_url" alt="" style='width:150px;'>
            </div>
            <div slot="footer">
                <Button type='primary' shape="circle" ghost @click='cancel'>关闭</Button>
            </div>
        </Modal>
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>

<style>
    .ivu-select-dropdown {
        top: 30px!important;
    }
    
    .ivu-select {
        position: relative;
    }
    
    .details-box {
        line-height: 30px;
        font-size: 12px;
    }
    
    .details-box span {
        margin-right: 50px;
    }
    
    .school {
        float: left;
        font-size: 14px;
        line-height: 30px;
        margin-right: 10px;
        cursor: pointer;
        padding: 0 10px;
    }
    
    .school.active {
        background: #ddd;
    }
    
    .active {
        border-bottom: 2px solid #000;
        padding-bottom: 10px;
    }
    
    .type-list {
        cursor: pointer;
    }
</style>
<script>
    import {
        fetchTableList,
        fetchInfo,
      
    } from '@/api/orderList'
    import {
        fetchSchoolList,
        fetchProxyList
      
    } from '@/api/common'

    export default {
        name: 'user-components',
        data () {
            return {
                total_count: 0, //列表总条数
                total_money:0,
                formItem:{
                    page: 1, //列表当前页数
                    page_size: 10,
                    pay_status: '', 
                    start_time: '',
                    end_time: '',
                    school_id:'',
                    phone:'',
                    sys_order_num:'',

                },
                start_time: '',
                end_time: '',
                proxyList:[],
                detailsModal:false,//详情弹框
                detailsFrom:{

                },
                statusList:[
                    {id:1,name:'已支付'},
                    {id:0,name:'未支付'},
                ],
                refundStatus:false,
                schoolColumns:[
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
                    {
                        title: '学校名称',
                        align: 'center',
                        key: 'school_name',

                    },
                    {
                        title: '学院人数',
                        align: 'center',
                        key: 'student_num',
                    },

                ],
                schoolData:[],
                schoolList:[],
                editIncellColumns: [
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
                
                    {
                        title: '订单号',
                        align: 'center',
                        key: 'sys_order_num',

                    },
                    {
                        title: '手机号',
                        align: 'center',
                        key: 'phone',
                    },
                    {
                        title: '姓名',
                        align: 'center',
                        key: 'nickname',
                        
                    },
                    {
                        title: '价格',
                        align: 'center',
                        key: 'money',
                    },
                    {
                        title: '校区',
                        align: 'center',
                        key: 'school_name',
                    },
                    {
                        title: '下单时间',
                        align: 'center',
                        key: 'create_at',
                        width:150,
                    },
                    {
                        title: '支付时间',
                        align: 'center',
                        key: 'pay_at',
                        width: 150,
                    },
                    {
                        title: '支付状态',
                        align: 'center',
                        key: 'pay_status',
                        render: (h, params) => {
                            if(params.row.pay_status==0){
                                return h('span', '未支付')
                            }else{
                                return h('span', '已支付')
                            }
                        }
                    },
                    //  {
                    //     title: '订单状态',
                    //     align: 'center',
                    //     key: 'status',
                    //     render: (h, params) => {
                    //         if(params.row.status==1){
                    //             return h('span', '正常')
                    //         }else{
                    //             return h('span', '禁用')
                    //         }
                    //     }
                    // },
                   
                    {
                        title: '操作',
                        align: 'center',
                        key: 'action',
                        width: 120,
                        render: (h, params) => {
                            return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'info',
                                            size: 'small',
                                            ghost: true

                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.seeInfo(params.row.id)
                                            }
                                        }
                                    }, '查看详情'),
                                  
                            ])
                        }
                    }
                
                ],//列表
                editIncellData: [],//列表数据
            };
        },
        methods: {
            //获取列表数据
            getData () {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res=res.data;
                    this.$Loading.finish();
                    if(res.code == 200){
                        this.editIncellData = res.data.list;
                        this.total_money=res.data.total_money;
                        this.total_count = parseInt(res.data.total_count);
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
            getSchoolList(){
                fetchSchoolList().then(res => {
                    res=res.data;
                    if(res.code == 200){
                        this.schoolList = res.data;
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
            getProxyList(){
                fetchProxyList().then(res => {
                    res=res.data;
                    if(res.code == 200){
                        this.proxyList = res.data;
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
            seeInfo(id){
                fetchInfo({
                    id:id
                }).then(res => {
                    res=res.data;
                    if(res.code == 200){
                        this.detailsFrom = res.data;
                        this.detailsModal=true;
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },

          
             // 改变开始时间
            changStarttime(time) {
                if (time == '') {
                    this.formItem.start_time = '';
    
                } else {
                    this.formItem.start_time = new Date(time).getTime() / 1000 - 28800;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 改变结束时间
            changEndtime(time) {
                if (time == '') {
                    this.formItem.end_time = '';
    
                } else {
                    this.formItem.end_time = new Date(time).getTime() / 1000 + 57600;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 取消关闭弹层
            cancel(){
                this.addModel=false;
                this.detailsModal=false;
            },
           
            //搜索框搜索
            handleSearch () {
                this.formItem.page = 1;
                this.getData();
            },
            //改变当前页码
            changePage (row) {
                this.formItem.page = row;
                this.getData();
            },
            
        },
        created () {
            this.getData();
            this.getSchoolList();
            this.getProxyList();
        }
    };
</script>
